// extracted by mini-css-extract-plugin
module.exports = {"footer":"index_footer_3xLiz","footerInner":"index_footerInner_1a0tp","logo":"index_logo_16es0"};